// ACompleterBlock — section « À compléter » de la fiche dossier TEF.
// CC-DEV1-17 #1 — extraite d'InfosTab et déplacée vers l'onglet Demande MPA.
// Source unique de la logique « items à compléter » (contrat/mandat/installateur
// non posés + RFR/âge manquants). VueGlobale.jsx garde sa propre liste « blocages »
// (gating pipeline) — distincte, non touchée.
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { BlockCard } from "../../../components/BlockCard";
import { getClientAge } from "../../../utils/clientFormat";
// 🔴🔴 N°739 — « À COMPLÉTER » RÉCLAMAIT À UN PEINTRE LES PIÈCES D'UN DOSSIER
// D'AIDES. ⚠️ MESURÉ : la liste est EN DUR ici (⛔ elle n'est PAS déclarée par
// tenant), et ses CINQ exigences relèvent toutes de l'AMO — le mandat est celui
// du mandataire ANAH, le RFR et l'âge sont les critères d'éligibilité MPA, et
// l'installateur est de la sous-traitance.
// 🔑 Chaque exigence suit désormais la capacité qui la rend VRAIE. Un tenant
// sans aides ⛔ ne se voit REPROCHER aucun de ces gestes.
// ⚠️ CE QUE CE LOT ⛔ NE FAIT PAS : inventer les exigences de Mario. Une liste
// déclarée par tenant est le bon modèle (comme `metier_config_listes`) ⛔ mais
// c'est une décision métier — signalée à JJ, ⛔ pas prise ici.
import { hasDossierAmo, hasDevisInstallateur } from "../../../utils/tenantProfile";
import { checklistCouvre, libellePieceManquante, piecesManquantes } from "./checklistAnah";

// T-242d — les PIÈCES manquantes viennent de la checklist ANAH (moteur `check_anah_checklist`, source unique) dès qu'elle est chargée ;
// sans elle (chargement, échec, tenant sans checklist) on garde les lignes historiques plutôt que d'afficher « rien à signaler » à tort.
export function ACompleterBlock({ dossier, checklist = null }) {
  const client = dossier?.client || {};
  const rfr = client.rfr ?? client.revenu_fiscal_reference ?? null;
  const age = getClientAge(client);

  const amo = hasDossierAmo();
  const piecesDuMoteur = amo && checklist ? piecesManquantes(checklist).map(libellePieceManquante) : null;
  const actions = [
    // Contrat AMO et mandat ANAH : le parcours d'aides.
    amo && !dossier?.contrat_signe && "Contrat non signé",
    amo && !dossier?.mandat_signe && !checklistCouvre(checklist, "MDA") && "Mandat non signé",
    // Sous-traitance de la pose : ⛔ personne à assigner quand on pose soi-même.
    hasDevisInstallateur() && !dossier?.installateur_nom && "Installateur non assigné",
    // Critères d'éligibilité MPA (barème ANAH) : RFR et âge du bénéficiaire.
    ...(piecesDuMoteur
      ? [...piecesDuMoteur, amo && rfr == null && "RFR non renseigné", amo && age == null && "Date de naissance non renseignée"]
      : [amo && rfr == null && "Avis d'imposition manquant (RFR)", amo && age == null && "CNI manquante (âge)"]),
  ].filter(Boolean);

  return (
    <BlockCard collapsible testId="bloc-infos-actions" title="À compléter">
      {actions.length ? (
        <div className="space-y-1">
          {actions.map((a, i) => (
            <div key={i} className="flex items-center gap-2 text-xs" style={{ color: "var(--oh-text-secondary)" }}>
              <AlertTriangle className="w-3 h-3 flex-shrink-0" style={{ color: "var(--oh-stat-amber-text)" }} /> {a}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs flex items-center gap-2" style={{ color: "var(--oh-success-text)" }}><CheckCircle2 className="w-3.5 h-3.5" /> Rien à signaler.</p>
      )}
    </BlockCard>
  );
}

export default ACompleterBlock;
